<template>
  <div v-if="true">
    <div v-if="btnSpinAppendToMaster === false">
      <v-btn
      :color="ui.btnColor"
      icon v-if="data.size == 'icon'"
      @click="AppendDocumentToMaster(true)"
      flat dark>
        <v-icon :color="btn.Color"> {{btn.icon}} </v-icon>
      </v-btn>
      <v-btn
      :color="ui.btnColor"
      v-if="data.size == 'flat' || data.size == undefined"
      @click="AppendDocumentToMaster(true)"
      flat dark>
        <v-icon left :color="btn.Color"> {{btn.icon}} </v-icon>
          {{btn.title}}
      </v-btn>
    </div>
    <div v-else>
      <BtnSpin dark v-if="data.size == 'icon'" :btnSpec="btnInfo1"/>
      <BtnSpin dark v-if="data.size == 'flat'" :btnSpec="btnInfo2"/>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import createFirebase from "@/data/cloud/firebase/mixins/createFirebase.js";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import getList from "@/data/cloud/firebase/mixins/getList.js";
export default {
  // eslint-disable-next-line
  mixins: [
    createFirebase,
    apptheme,
    getList,
    dataSources
  ],
  methods: {
    AppendDocumentToMaster(logic) {
      let doc = this.data.detail;
      this.btnSpinAppendToMaster = true;
      if (logic === true) {
        this.createDocumentCopyToMaster(doc, "B6.W");
      }
    }
  },
  computed: {
    ...mapGetters(["getCurrentPage", "getDetailBasic"]),
    btn() {
      let obj = {
        title: "",
        icon: "",
        color: ""
      };
      if (
        this.getDetailBasic.tag === "W1" ||
        this.getDetailBasic.tag === "W2"
      ) {
        obj.title = "ADD WORK TO PLAN";
        obj.icon = "add";
        obj.color = this.ui.btnColor;
      }
      return obj;
    }
  },
  props: {
    data: {
      type: Object
    }
  },
  components: {
    BtnSpin
  },
  data() {
    return {
      valid: false,
      btnSpinAppendToMaster: false,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: "icon"
      },
      btnInfo2: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: ""
      }
    };
  }
};
</script>
